import { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { FaGraduationCap } from 'react-icons/fa';
import { usePortfolio } from '../../context/PortfolioContext';

const Education = () => {
  const { portfolioData } = usePortfolio();
  const education = portfolioData?.education || [];

  const visibleEducation = education.filter(edu => edu.visible);

  if (!visibleEducation.length) {
    return (
      <div className="py-8">
        <h3 className="text-2xl font-semibold text-white mb-8 flex items-center gap-3">
          <FaGraduationCap className="text-primary" />
          Education
        </h3>
        <div className="text-gray-400">No education data available. Please add entries in the admin dashboard.</div>
      </div>
    );
  }

  return (
    <div className="py-8">
      <h3 className="text-2xl font-semibold text-white mb-8 flex items-center gap-3">
        <FaGraduationCap className="text-primary" />
        Education
      </h3>
      <div className="space-y-8">
        {visibleEducation.map((item, index) => (
          <motion.div 
            key={item.id || index}
            className="relative pl-8 border-l-2 border-gray-700 pb-8 last:pb-0"
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: index * 0.1 }}
          >
            <div className="absolute -left-[9px] top-0 h-4 w-4 rounded-full bg-primary"></div>
            <div className="bg-secondary/30 p-6 rounded-lg border border-primary/10">
              <div className="flex flex-col md:flex-row md:justify-between md:items-start mb-2">
                <h4 className="text-xl font-medium text-white">{item.degree}</h4>
                <span className="inline-block px-3 py-1 rounded-full bg-primary/20 text-primary text-sm">
                  {item.year}
                </span>
              </div>
              <p className="text-gray-300 mb-2">{item.institution}, {item.location}</p>
              {item.image_url && (
                <img src={item.image_url} alt="Education" className="mb-2 h-20 rounded border border-gray-700" />
              )}
              <p className="text-gray-400">{item.description}</p>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default Education; 